import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { applyRecommendation, queryRecommendations } from '@wix/ambassador-ai-scheduling-assistant-v1-recommendation/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { RecommendationsClientBase } from './RecommendationsClientBase';
export class RecommendationsClient extends HttpBaseClient(RecommendationsClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "queryRecommendationsImpl", queryRecommendations);
    _defineProperty(this, "applyRecommendationImpl", applyRecommendation);
  }
}
//# sourceMappingURL=RecommendationsClientHttp.js.map